/* istanbul ignore file */
import { SAVE_LEAD_VALIDATIONS } from '../constants/actionTypes'

const initialState = {}

const initialLeadValidationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_LEAD_VALIDATIONS:
      return Object.assign({}, state, action.validations)
    default:
      return state
  }
}

export default initialLeadValidationsReducer
export { initialState }
